import type { FunctionComponent } from 'react';

import { Avatar as FlowbiteAvatar } from 'flowbite-react';

import type { AvatarProps } from './types';

const customThemeAvatar = {
  root: {
    base: 'flex items-center justify-center space-x-4 rounded',
    bordered: 'p-1 ring-2',
    rounded: 'rounded-full',
    img: {
      base: 'rounded',
      off: 'relative overflow-hidden !bg-s100',
      on: '',
      placeholder: ''
    },
    initials: {
      text: 'font-medium uppercase text-dark',
      base: 'relative inline-flex items-center justify-center overflow-hidden'
    },
    size: {
      sm: 'h-8 w-8',
      md: 'h-10 w-10',
      lg: 'h-20 w-20'
    },
    statusPosition: {
      "bottom-left": "-bottom-1 -left-1",
      "bottom-center": "-bottom-1",
      "bottom-right": "-bottom-1 -right-1",
      "top-left": "-left-1 -top-1",
      "top-center": "-top-1",
      "top-right": "-right-1 -top-1",
      "center-right": "-right-1",
      "center": "",
      "center-left": "-left-1"
    },
    status: {
      "away": "bg-yellow-400",
      "base": "absolute h-3.5 w-3.5 rounded-full border-2 border-n50_hover dark:border-bg_dark",
      "busy": "bg-brand",
      "offline": "bg-gray-400",
      "online": "bg-green-400"
    },
  }
};

const sizeVariants = {
  large: 'lg',
  medium: 'md',
  small: 'sm'
};

export const Avatar: FunctionComponent<AvatarProps> = ({ sizing = 'medium', ...props }) => {
  return <FlowbiteAvatar {...props} theme={customThemeAvatar} size={sizeVariants[sizing]} />;
};
